// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input, OnInit } from '@angular/core';
import { Deal, DealStatuses } from '@interfaces/deal.interfaces';
import { getImage, getMissingImage, showMissingImage } from 'src/app/utils/utils';

@Component({
    selector: 'dealer-deal-card',
    templateUrl: './dealer-deal-card.component.html',
    styleUrls: ['./dealer-deal-card.component.scss'],
})
export class DealerDealCardComponent implements OnInit {
    @Input() deal: Deal = null;
    @Input() dealUrl: string[];
    documentLastUpdatedDays: any;
    vehicleImage: string | null = null;

    protected readonly DealStatuses = DealStatuses;

    ngOnInit(): void {
        this.getVehicleImage();
    }

    public async getVehicleImage(): Promise<any> {
        await getImage(this.deal).then((image) => {
            if (image.includes('https') || image.includes('assets/')) {
                this.vehicleImage = image;
            } else {
                this.vehicleImage = 'data:image/webp;base64, ' + image;
            }
        });
    }

    public getLastDocumentUpdateDate(): any {
        //lastDocumentUploadDate is not necessarily the "upload" date as it is actually the last update date of a document
        const lastUpdateDate = new Date(this.deal.lastDocumentUploadDate);

        const today = new Date();
        const timeDifference = today.getTime() - lastUpdateDate.getTime();

        // To calculate the no. of days between two dates
        const daysDifference = Math.round(timeDifference / (1000 * 3600 * 24));

        // Display the number of days or Today
        this.documentLastUpdatedDays = daysDifference === 0 ? 'Today' : daysDifference;

        // Drop off after 5 days
        return isNaN(daysDifference) ? daysDifference : daysDifference < 6;
    }

    get redirect() {
        if (window.location.pathname.includes('pddj')) {
            return ['/pddj', '' + this.deal.dealId, 'upload'];
        } else {
            return ['/dashboard', 'deals', this.deal.dealId];
        }
    }

    public showMissingImage($event): any {
        showMissingImage($event);
    }

    displayCategory(statusId: DealStatuses): string {
        let displayCategory = DealStatuses[statusId];

        if (displayCategory === 'Completed') displayCategory = 'Closed';

        return displayCategory;
    }

    isCategoryType(categories: DealStatuses[]): boolean {
        return categories.includes(this.deal.statusId);
    }
}
